import React from "react";
import Avatar from "@mui/material/Avatar";
import StarRating from "./StarRating";

const ReviewCard = ({ review }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  return (
    <div
      className="mb-4 pb-4"
      style={{
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <div className="d-flex align-items-start gap-3">
        <Avatar
          alt={review?.user_name || "User"}
          src={review?.user_profile || ""}
          sx={{ width: 40, height: 40 }}
        />
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2 mb-2">
            <StarRating rating={review?.rating} readOnly={true} size="small" />
          </div>
          <p className="mb-1 fw-bold" style={{ fontSize: "14px" }}>
            {review?.user_name || "Anonymous"}
          </p>
          <p className="mb-2" style={{ fontSize: "14px", color: "#666" }}>
            {review?.comment || review?.description || ""}
          </p>
          <p className="mb-0" style={{ fontSize: "12px", color: "#999" }}>
            {formatDate(review?.created_at || review?.date)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;

